module.exports = __webpack_public_path__ + "static/icon-aereo-7-fb221b34e4b6a3afcd390abb7accd960.svg";